import { type PatientProfileFormSchema } from '@/components/modal/patient-profile-form-modal/form/schemas';
import { cn } from '@/lib/cn';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@heidi/design-system/form';
import { Input } from '@heidi/design-system/input';
import { TypographyP2Bold } from '@heidi/design-system/typography';
import { type patientInputFieldNames } from '@heidi/patients';
import { type Control } from 'react-hook-form';
import { type z } from 'zod';

interface PatientInputFieldProps {
  name: patientInputFieldNames;
  label: string;
  placeholder: string;
  isDisabled: boolean;
  control: Control<z.infer<typeof PatientProfileFormSchema>>;
  className?: string;
}

export const PatientInputField = ({
  name,
  label,
  placeholder,
  isDisabled,
  control,
  className,
}: PatientInputFieldProps) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex w-full flex-col gap-1">
          <FormLabel>
            <TypographyP2Bold>{label}</TypographyP2Bold>
          </FormLabel>
          <FormControl>
            <Input
              disabled={isDisabled}
              {...field}
              placeholder={placeholder}
              wrapperClassName={cn(className)}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
